import type { ProfileBasicsValues } from 'utils/shared/playerFinder';
import { AboutMeInput, BirthdayField, GenderField } from 'components/PlayerFinder';
import ModalField from './ModalField';
import ProfileFormModal from './ProfileFormModal';
import type { ProfileEditorModalProps } from './types';
import { useModalDraft } from './useModalDraft';

type AboutMeValues = Pick<
  ProfileBasicsValues,
  'aboutMe' | 'gender' | 'birthday' | 'birthdayVisibility'
>;

interface Props extends ProfileEditorModalProps {
  defaultValues: AboutMeValues | null;
  onSave: (values: AboutMeValues) => Promise<boolean>;
}

export default function AboutMeFormModal({
  isOpen,
  onClose,
  defaultValues,
  onSave,
  isSaving,
  error,
}: Props) {
  const { values, setValues, handleSave } = useModalDraft(isOpen, defaultValues, onSave, onClose);

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="About Me"
      description="Tell players a bit about yourself so they know what to expect."
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    >
      {values && (
        <>
          <ModalField label="About me">
            <AboutMeInput
              rows={4}
              value={values.aboutMe}
              onChange={(aboutMe) => setValues({ ...values, aboutMe })}
            />
          </ModalField>

          <ModalField label="Gender">
            <GenderField
              name="profile-gender"
              value={values.gender}
              onChange={(gender) => setValues({ ...values, gender })}
            />
          </ModalField>

          <ModalField label="Birthday">
            <BirthdayField
              birthday={values.birthday}
              onBirthdayChange={(birthday) => setValues({ ...values, birthday })}
              visibility={values.birthdayVisibility}
              onVisibilityChange={(birthdayVisibility) =>
                setValues({ ...values, birthdayVisibility })
              }
            />
          </ModalField>
        </>
      )}
    </ProfileFormModal>
  );
}
